<template>
  <section>
    <b-modal :active.sync="OpenModalEditQuestionary" has-modal-card :can-cancel="false">
      <form action v-on:submit.prevent="changeEdit">
        <div class="modal-card">
          <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
          <header class="modal-card-head">
            <p class="modal-card-title">Editar Encuesta</p>
          </header>
          <section class="modal-card-body">
            <b-field label="Nombre">
              <b-input
                type="text"
                :value="questionarie.name"
                v-model="questionarie.name"
                placeholder="Nombre"
                required
              ></b-input>
            </b-field>
            <b-field label="Descripcion">
              <b-input
                type="input"
                :value="questionarie.description"
                v-model="questionarie.description"
                placeholder="Descripcion"
                required
              ></b-input>
            </b-field>
            <b-field grouped>
              <b-field label="Fecha de Inicio">
                <b-input
                  type="date"
                  :value="questionarie.date_start"
                  v-model="questionarie.date_start"
                  placeholder="Nombre"
                  required
                ></b-input>
              </b-field>
              <b-field label="Fecha de Término">
                <b-input
                  type="date"
                  :value="questionarie.date_end"
                  v-model="questionarie.date_end"
                  placeholder="Nombre"
                  required
                ></b-input>
              </b-field>
              <b-field label="¿Mostrar Resultados?">
                <b-select v-model="questionarie.show_results">
                  <option value="0">No</option>
                  <option value="1">Si</option>
                </b-select>
              </b-field>
            </b-field>
            <b-field grouped>
              <b-field label="¿Termino de Condiciones?">
                <b-select v-model="questionarie.term_required">
                  <option value="0">No</option>
                  <option value="1">Si</option>
                </b-select>
              </b-field>
              <b-field
                label="Seleccionar Termino de Condición"
                v-if="questionarie.term_required == 1"
              >
                <b-select
                  placeholder="Seleccionar el Termino de Condición"
                  v-model="questionarie.term_id"
                  expanded
                >
                  <option v-for="term in listTerms" :value="term.id" :key="term.id">{{ term.title }}</option>
                </b-select>
              </b-field>
            </b-field>
            <b-field label="Seleccionar Locación">
              <b-taginput
                v-model="locationSelected"
                :data="filteredTags"
                autocomplete
                :allow-new="false"
                :open-on-focus="true"
                field="name"
                placeholder="Seleccionar"
                @input="filteredTags = listLocation"
                @typing="getFilteredTags"
              ></b-taginput>
            </b-field>
             <b-field label="Seleccionar Estamento" >
              <b-taginput  
                v-model="estamentSelected"
                :data="filteredStament"
                autocomplete
                :allow-new="false"
                :open-on-focus="true"
                field="name"
                placeholder="Seleccionar"
                @input="filteredStament = listEstament"
               
              ></b-taginput>
            </b-field>
          </section>
          <footer class="modal-card-foot">
            <button class="button" type="button" @click="closeBasic()">Cerrar</button>
            <button class="button is-primary" type="submit">Guardar</button>
          </footer>
        </div>
      </form>
    </b-modal>
  </section>
</template>
<script>
import { getLocations } from "../../../services/location";
import { getTerms } from "../../../services/terms";
import {
  getQuestionarie,
  editQuestionarie,
} from "../../../services/questionarie";
import {
  storeQuestionLocation,
  deleteQuestionaryLocation,
} from "../../../services/question_location";
import {
  storeEstamentRestrict,
  deleteEstamentRestrict,
} from "../../../services/restriction";
import { getStament } from "../../../services/stament";

export default {
  props: [
    "OpenModalEditQuestionary",
    "closeBasic",
    "chargeQuestionarieList",
    "questionarie_id",
  ],
  data() {
    return {
      questionarie: {
        name: "",
        description: "",
        date_start: "",
        date_end: "",
        state: "",
        term_id: 1,
        term_required: false,
        show_results: false,
        restriction: true,

      },
      filteredTags: [],
      listLocation: [],
      locationSelected: [],
      listTerms: [],
      locationSelectedOriginal: [],
      estamentSelectedOriginal: [],

      filteredStament: [],
      listEstament:[],
      estamentSelected:[],
      isLoading: false,
    };
  },
  created: async function () {
    this.isLoading = true;
    await this.chargeData();
    await this.showLocation();
    await this.showTerms();
    this.isLoading = false;
  },
  methods: {
    async showTerms() {
      this.listTerms = await getTerms(this.$http);
    },
    getFilteredTags(text) {
      this.filteredTags = this.listLocation.filter((option) => {
        return (
          option.name.toString().toLowerCase().indexOf(text.toLowerCase()) >= 0
        );
      });
    },
    getFilteredEstament(text) {
      this.filteredStament = this.listEstament.filter((option) => {
        return (
          option.name.toString().toLowerCase().indexOf(text.toLowerCase()) >= 0
        );
      });
    },
    async showLocation() {
      await getLocations(this.$http).then((response) => {
        console.log("Prueba", response);
        this.listLocation = response.map((location) => {
          return {
            name: location.name,
            id: location.id,
          };
        });
        this.filteredTags = response;
      });
       await getStament(this.$http).then((response) => {
        console.log("Prueba", response);
        this.listEstament = response.map((location) => {
          return {
            name: location.name,
            id: location.id,
          };
        });
        this.filteredStament = response;
      });
    },
    async chargeData() {
      await getQuestionarie(this.$http, this.questionarie_id).then(
        (response) => {
          this.questionarie = response;
          response.questionaries_locations.forEach((questionary_location) => {
            this.locationSelected.push({
              name: questionary_location.location.name,
              stablishment_name:questionary_location.location.stablishment.name,
              questionary_location: questionary_location.id,
              id: questionary_location.location_id,
            });
          });
           response.restrictions.forEach((stament) => {
            this.estamentSelected.push({
              name: stament.stament.name,
              restriction_id: stament.id,
              id: stament.stament.id,
            });
          });

          
          this.locationSelectedOriginal = this.locationSelected;
          this.estamentSelectedOriginal = this.estamentSelected;

        }
      );
    },
    checkLocations() {
      let storeLocations = [];
      let deleteLocations = [];
      //STORE LOCATIONS
      this.locationSelected.forEach((location) => {
        let isInOriginal = false;
        this.locationSelectedOriginal.forEach((locationOriginal) => {
          if (locationOriginal.id === location.id) {
            isInOriginal = true;
          }
        });
        if (!isInOriginal) {
          storeLocations.push({
            location_id: location.id,
            questionarie_id: this.questionarie_id,
          });
        }
      });
      //DELETE LOCATIONS
      this.locationSelectedOriginal.forEach((locationOriginal) => {
        let isInOriginal = false;
        this.locationSelected.forEach((location) => {
          if (locationOriginal.id === location.id) {
            isInOriginal = true;
          }
        });
        if (!isInOriginal) {
          deleteLocations.push({
            ...locationOriginal,
          });
        }
      });

      console.log("storeLocations", storeLocations);
      console.log("deleteLocations", deleteLocations);

      return {
        storeLocations,
        deleteLocations,
      };
    },
        checkEstament() {
      let storeEstament = [];
      let deleteEstament = [];
      //STORE LOCATIONS
      this.estamentSelected.forEach((stament) => {
        let isInOriginal = false;
        this.estamentSelectedOriginal.forEach((estamentOriginal) => {
          if (estamentOriginal.id === stament.id) {
            isInOriginal = true;
          }
        });
        if (!isInOriginal) {
          storeEstament.push({
            stament_id: stament.id,
            questionarie_id: this.questionarie_id,
          });
        }
      });
      //DELETE LOCATIONS
      this.estamentSelectedOriginal.forEach((estamentOriginal) => {
        let isInOriginal = false;
        this.estamentSelected.forEach((stament) => {
          if (estamentOriginal.id === stament.id) {
            isInOriginal = true;
          }
        });
        if (!isInOriginal) {
          deleteEstament.push({
            ...estamentOriginal,
          });
        }
      });

      console.log("storeEstament", storeEstament);
      console.log("deleteEstament", deleteEstament);

      return {
        storeEstament,
        deleteEstament,
      };
    },
    async changeEdit() {
      if (this.locationSelected.length !== 0) {
        this.isLoading = true;
        await getQuestionarie(this.$http, this.questionarie_id).then(
          async (response) => {
            let data = {
              ...response,
              ...this.questionarie,
              term_id: this.questionarie.term_required == 0 ? 1 : this.questionarie.term_id,
            };
            await editQuestionarie(this.$http, this.questionarie_id, data).then(
              async () => {
                let result = this.checkLocations();

                if (result.deleteLocations.length !== 0) {
                  for (let i = 0; i < result.deleteLocations.length; i++) {
                    console.log(result.deleteLocations, i);
                    await deleteQuestionaryLocation(
                      this.$http,
                      result.deleteLocations[i].questionary_location
                    );
                  }
                }

                if (result.storeLocations.length !== 0) {
                  for (let i = 0; i < result.storeLocations.length; i++) {
                    await storeQuestionLocation(this.$http, {
                      questionary_id: this.questionarie_id,
                      location_id: result.storeLocations[i].location_id,
                    });
                  }
                }
               let result2 = this.checkEstament();

                if (result2.deleteEstament.length !== 0) {
                  for (let i = 0; i < result2.deleteEstament.length; i++) {
                    console.log(result2.deleteEstament, i);
                    await deleteEstamentRestrict(
                      this.$http,
                      result2.deleteEstament[i].restriction_id
                    );
                  }
                }

                if (result2.storeEstament.length !== 0) {
                  for (let i = 0; i < result2.storeEstament.length; i++) {
                    await storeEstamentRestrict(this.$http, {
                      questionary_id: this.questionarie_id,
                      stament_id: result2.storeEstament[i].stament_id,
                    });
                  }
                }

                this.isLoading = false;
                this.chargeQuestionarieList();
                this.closeBasic();
                this.toast("Editado", "is-success");
              
              }
            );
          }
        );
      } else {
        this.toast("Por favor seleccione al menos una locación", "is-warning");
      }

    },
  },
};
</script>